// iOS-style switch. Caller controls the value and gets a flipped value
// in onChange. Color and labels are configurable so the same component
// works for "Active/Hidden", "Open/Closed", etc.
export function Toggle({
  active,
  onChange,
  labelOn,
  labelOff,
  disabled,
  testid,
  color = "success",
}: {
  active: boolean;
  onChange: (next: boolean) => void;
  labelOn?: string;
  labelOff?: string;
  disabled?: boolean;
  testid?: string;
  color?: "success" | "primary";
}) {
  const onBg = color === "primary" ? "bg-primary" : "bg-success";
  const onText = color === "primary" ? "text-primary" : "text-success";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={active}
      onClick={() => onChange(!active)}
      disabled={disabled}
      data-testid={testid}
      className="inline-flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <span
        className={`relative inline-flex h-5 w-9 shrink-0 rounded-full transition-colors duration-150 ${
          active ? onBg : "bg-border"
        }`}
      >
        <span
          className={`absolute top-0.5 h-4 w-4 rounded-full bg-white shadow-xs transition-transform duration-150 ${
            active ? "translate-x-4" : "translate-x-0.5"
          }`}
        />
      </span>
      {(labelOn || labelOff) && (
        <span
          className={`text-xs font-semibold ${active ? onText : "text-muted"}`}
        >
          {active ? labelOn : labelOff}
        </span>
      )}
    </button>
  );
}
